﻿/**
 * Input Sanitization Utilities
 * Connect Source Architecture
 */

export function sanitizeString(input: string): string {
  if (!input) return '';
  return input
    .replace(/[<>]/g, '') // Strip HTML brackets to prevent stored XSS
    .trim();
}

export function sanitizeEmail(email: string): string {
  if (!email) return '';
  return email.trim().toLowerCase();
}

export function maskEmail(email: string): string {
  const parts = email.split('@');
  if (parts.length !== 2) return '***';
  const name = parts[0];
  const domain = parts[1];
  const maskedName = name.length > 2 
    ? `${name[0]}***${name[name.length - 1]}` 
    : '***';
  return `${maskedName}@${domain}`;
}

